module.exports = __webpack_public_path__ + "img/1512015144.75086a2e.jpg";